<ng-template #addC let-c="close" let-d="dismiss">
  <div class="modal-header d-flex flex-row justify-content-between">
    <h2 class="text-center">{{ 'settings-clients-add-client-form-title' | translate }}</h2>
    <button type="button" class="modal-close" aria-label="Close" (click)="c('Cross click')"></button>
  </div>
  <div class="modal-body add-modal">
    @if (form) {
    <div class="d-flex flex-column align-items-center">
      <table>
        <tr>
          <td>
            <input class="form-control mb-2" [placeholder]="'settings-clients-add-client-client-name' | translate"
              [formControl]="getFormControl('name')">
          </td>
        </tr>
      </table>

      @if (getFormControl('name').invalid && getFormControl('name').dirty) {
      <div class="alert alert-danger">
        @if (getFormControl('name').errors?.['required']) {
        <div>{{ 'setting-form-error-required' | translate }}</div>
        }
        @if (getFormControl('name').errors?.['exist']) {
        <div>{{ 'setting-form-error-already-exist' | translate }}</div>
        }
        @if (getFormControl('name').errors?.['whitespace'] && !getFormControl('name').errors?.['required']) {
        <div>{{ 'setting-form-error-invalid-value' | translate }}</div>
        }
      </div>
      }
      <button type="button" class="btn btn-outline-success mt-2" [disabled]="form.invalid"
        (click)="emitAddClient(); c('Save changes')">{{ 'confirm' | translate }}</button>
    </div>
    }
  </div>
</ng-template>

<ng-template #addA let-c="close" let-d="dismiss">
  <div class="modal-header d-flex flex-row justify-content-between">
    <h2 class="text-center">{{ 'settings-clients-add-app-form-title' | translate }}</h2>
    <button type="button" class="modal-close" aria-label="Close" (click)="c('Cross click')"></button>
  </div>
  <div class="modal-body add-modal">
    <table class="table">
      <tbody>
        <tr>
          <td>
            <h4>{{ 'settings-clients-add-app-form-app-name' | translate }}</h4>
          </td>
          <td>
            @if (form) {
              <div class="d-flex flex-column justify-content-center align-items-center block">
                <input class="form-control" [formControl]="getFormControl('packageName')">
                @if (getFormControl('packageName').invalid && getFormControl('packageName').dirty) {
                  <div class="alert alert-danger">
                    @if (getFormControl('packageName').errors?.['required']) {
                      <div>{{ 'setting-form-error-required' | translate }}</div>
                    }
                    @if (getFormControl('packageName').errors?.['exist']) {
                      <div>{{ 'setting-form-error-already-exist' | translate }}</div>
                    }
                    @if (getFormControl('packageName').errors?.['whitespace'] && !getFormControl('packageName').errors?.['required']) {
                      <div>{{ 'setting-form-error-invalid-value' | translate }}</div>
                    }
                  </div>
                }
              </div>
            }
          </td>
        </tr>
        <tr>
          <td class="title">
            <div class="d-flex align-items-center">
              <h4>{{ 'security-policies-form-add-os' | translate }}</h4>
            </div>
          </td>
          <td class="form">
            <div class="d-flex align-items-center justify-content-center block">
              <div ngbDropdown class="d-inline-block">
                <button type="button" class="btn text-capitalize" id="os" ngbDropdownToggle>
                  <img src="assets/icons/logosOS/{{form?.value['os']?.toLowerCase()}}.svg">
                  {{ form?.value['os'] }}
                </button>
                <div class="d-flex justify-content-center block">
                  <div ngbDropdownMenu aria-labelledby="os">
                    @for (os of formOSChoices; track os) {
                      <button ngbDropdownItem (click)="setOs(os)">
                        <div class="d-flex flex-row align-items-center">
                          <img src="assets/icons/logosOS/{{os.toLowerCase()}}.svg">
                          <p class="text-capitalize">{{ os }}</p>
                        </div>
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="title">
            <h4>{{ 'settings-clients-add-client-client' | translate }}</h4>
          </td>
          <td class="form">
            <div class="d-flex justify-content-center block">
              @if (client) {
                <button class="dropdown-toggle" [disabled]="true">
                  {{ client.name }}
                </button>
              }
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex flex-column align-items-center">
      <button type="button" class="btn btn-outline-success" [disabled]="form?.invalid"
        (click)="emitAddAppli(); c('Save changes')">{{ 'confirm' | translate }}</button>
    </div>
  </div>
</ng-template>

<ng-template #deleteAC let-c="close" let-d="dismiss">
  <div class="modal-body delete-modal">
    <div class="d-flex flex-column align-items-center">
      @if (client && !application) {
      <h2>
        {{ 'settings-clients-delete-client-form-title' | translate }}
        <b>{{ client.name }} ?</b>
      </h2>
      }
      @if (client && application) {
      <h2>
        {{ 'settings-clients-delete-app-form-title' | translate }}
        <b>{{ application.packageName }} ?</b>
      </h2>
      }
      @if (!application && mapClient.size > 0) {
      <div class="d-flex flex-column align-items-center justify-content-center">
        <h3>{{ 'settings-clients-delete-client-form-app' | translate }}</h3>
        @for (item of mapClient | keyvalue: originalOrder; track item) {
        <div class="d-flex flex-row justify-content-around tableClientApp">
          <img class="headimg" src="assets/icons/logosOS/{{item.key}}.svg">
          <table>
            @if (item.value && item.value.length > 0) {
            <tbody>
              @for (app of item.value; track app) {
              <tr>
                <td class="text-start">{{ app?.id }}</td>
                <td class="text-end">{{ app?.packageName }}</td>
              </tr>
              }
            </tbody>
            }
          </table>
        </div>
        }
      </div>
      }
      @if (!application && mapClient.size == 0) {
      <div class="d-flex flex-row justify-content-around align-items-center noApp">
        <img id="notfound" src="assets/images/Components/notfoundalone.svg">
        <h3>{{ "settings-clients-no-app" | translate }}</h3>
      </div>
      }
      <div class="d-flex flex-row justify-content-around mt-3">
        <button type="button" class="btn btn-outline-primary" (click)="c('Cross click')">{{ 'cancel' | translate
          }}</button>
        <button type="button" class="btn btn-outline-success" (click)="emitDelete(); c('Save changes')">{{ 'confirm' |
          translate }}</button>
      </div>
    </div>
  </div>
</ng-template>

@if (type === 'delete') {
<img type="button" (click)="open({ content: deleteAC })" class="delete" src="assets/icons/Policies/cross.svg">
}

@if (type === 'add-client') {
<div class="addpolicy d-flex flex-row justify-content-center align-items-center" type="button"
  (click)="open({ content: addC })">
  <img src="assets/icons/Policies/add.svg">
  <p>{{ 'settings-clients-add-client' | translate }}</p>
</div>
}

@if (type === 'add-app') {
<div class="addpolicy d-flex flex-row justify-content-center align-items-center" type="button"
  (click)="open({ content: addA })">
  <img src="assets/icons/Policies/add.svg">
  <p>{{ 'settings-clients-add-application' | translate }}</p>
</div>
}